module.exports = {
  OK: 'Подтвердить',
  CANCEL: 'Отмена',
  login_TITLE: 'Вход',
  login_USERNAME: 'Имя пользователя:',
  login_PASSWORD: 'Пароль:',
  login_LANGUAGE: 'Язык:',
  login_SAVEPASSWORD: 'Сохранить пароль',
  login_failure: 'Неверное имя пользователя или пароль.',
  main_title: 'Управление экспедиторами',
  main_user: 'Пользователь:',
  main_office: 'Компания:',
  main_LOGOUT_TOOLTIP: 'Выйти',
  main_CHANGE_PASSWORD_TOOLTIP: 'Сменить пароль.',
  main_REFRESH_TOOLTIP: 'Обновить кэш.',
  main_HELP_TOOLTIP: 'Справка.',
  main_LOADING_MODULE_STATUS: 'Загрузка {0} ...',
  main_INITIALIZING_STATUS: 'Загрузка ...',
  main_REFRESHING_STATUS: 'Обновление кэша ...',
  password_title: 'Смена пароля',
  password_oldPassword: 'Текущий пароль:',
  password_newPassword: 'Новый пароль:',
  password_confirmTheNewPassword: 'Подтвердите новый пароль:',
  password_confirmPassword: 'Повторите пароль:',
  password_notMatch: 'Пароли не совпадают.',
  password_notCompliant: 'Пароль должен быть длиной от 8 до 20 символов и обязательно содержать цифру, заглавную и строчную букву.',
  password_noChange: 'Новый пароль не должен совпадать со старым.',
  password_failed: 'Не удалось изменить пароль. Проверьте данные и попробуйте снова.',
  PleaseEnterAOldPassword: 'Введите текущий пароль',
  PleaseEnterANewPassword: 'Введите новый пароль',
  PleaseEnterTheConfirmationPassword: 'Подтвердите новый пароль',
  TheNewPasswordDoesNotMatchTheConfirmedNewPassword: 'Новый пароль и подтверждение не совпадают',
  TheNewPasswordDoesNotMatchTheOldPassword: 'Новый пароль не должен совпадать со старым'
}
